export default function getPremierAutoRenewalUrl(
  subscriptionOptionId,
  offeredFreeTrial,
  trialOfferId
) {
  const isProduction = window.location.host === "www.asos.com";
  const myAsosDomain = isProduction
    ? "https://my.asos.com"
    : "https://my.asosservices.com";

  const url = new URL(`${myAsosDomain}/my-account/premier-delivery/`);

  const context = window?.asos && window.asos.webContext;
  const webContext = {
    currency: context.getBrowseCurrency(),
    language: context.getBrowseLanguage(),
  };

  url.searchParams.set("source", "landingpage");
  url.searchParams.set("language", webContext.language);
  url.searchParams.set("currency", webContext.currency);
  url.searchParams.set("subscriptionOptionId", subscriptionOptionId);
  url.searchParams.set("direct", "purchase");
  if (offeredFreeTrial) {
    url.searchParams.set("trialOfferId", trialOfferId);
  }

  return url.toString();
}
